import React from 'react'
import { useDispatch } from 'react-redux'
import * as R from 'ramda'

import { DEFAULT_JOBS_QUERY_PARAMS } from 'constants/projects'
import { toProjects } from 'ducks/router'
import { useModal } from 'hooks'
import { jobs } from 'orm'

const useDeleteJobModalMutations = () => {
  const dispatch = useDispatch()

  const handleDeleteJob = React.useCallback(
    ({ id }, { postSuccessAction } = {}) => {
      dispatch(jobs.deleteStart({ pk: R.toString(id), postSuccessAction }))
    },
    [dispatch],
  )

  return {
    handleDeleteJob,
  }
}

export const useDeleteJobModal = state => {
  const dispatch = useDispatch()

  const { id } = state

  const { handleClose, handleOpen, isOpen } = useModal()

  const { handleDeleteJob } = useDeleteJobModalMutations()

  const handleConfirm = React.useCallback(() => {
    handleDeleteJob(
      { id },
      {
        postSuccessAction: () => {
          handleClose()
          dispatch(toProjects(null, null, DEFAULT_JOBS_QUERY_PARAMS))
        },
      },
    )
  }, [id, dispatch, handleClose, handleDeleteJob])

  return {
    handleDeleteJobModalClose: handleClose,
    handleDeleteJobModalConfirm: handleConfirm,
    handleDeleteJobModalOpen: handleOpen,
    isDeleteJobModalOpen: isOpen,
  }
}
